import React, { Fragment } from "react"
import { useSelector, useDispatch } from "react-redux"
// import { useHistory } from "react-router-dom"
import {
  AppBar,
  Toolbar,
  IconButton,
  Box,
  Avatar,
  Typography
} from "@material-ui/core"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import MenuIcon from "@material-ui/icons/Menu"
import iconLogo from "assets/blue_icon.png"
// import { logout } from "actions/authentication"
import { toggleDrawer } from "actions/drawers"
import cloudinary from "cloudinary-core"
import noLogo from "assets/no-logo.png"

// import { openUpdateUserDialogFromProfile } from "actions/update-user-dialog"

const cl = new cloudinary.Cloudinary({
  cloud_name: process.env.REACT_APP_CLOUD_NAME
})
const AdminHeader = ({ classes }) => {
  // const { roleId, authenticatedUser } = useSelector(state => ({
  //   roleId: state.organization.currentOrg.role_id,
  // authenticatedUser: state.authentication.authenticatedUser
  // }))
  const { currentOrg } = useSelector(state => ({
    currentOrg: state.organization.currentOrg
  }))
  // const history = useHistory()
  const dispatch = useDispatch()
  // const [anchorEl, setAnchorEl] = useState(null)
  // const {
  //   first_name: firstName,
  //   last_name: lastName,
  //   phone,
  //   email,
  //   id,
  //   profile_image
  // } = authenticatedUser

  const handleOpenAdminDrawer = () => {
    dispatch(toggleDrawer())
  }

  // let role = ""

  // switch (roleId) {
  //   case 2:
  //     role = "administrator"
  //     break
  //   case 3:
  //     role = "moderator"
  //     break
  //   case 4:
  //     role = "user"
  //     break
  // }

  // const handleClick = event => {
  //   setAnchorEl(event.currentTarget)
  // }

  // const handleClose = () => {
  //   setAnchorEl(null)
  // }

  // const handleOpenUpdateUser = () => {
  //   dispatch(
  //     openUpdateUserDialogFromProfile({ firstName, lastName, phone, email, id })
  //   )
  //   setAnchorEl(null)
  // }

  // const handleLogoClick = () => {
  //   history.push("/app/feed")
  // }

  return (
    <Fragment>
      <AppBar className={classes.root} position="static" elevation={0}>
        <Toolbar>
          <Box className={classes.logoContainer}>
            <IconButton
              onClick={handleOpenAdminDrawer}
              className={classes.menuButton}
              color="primary"
            >
              <MenuIcon />
            </IconButton>
            {/* <Button onClick={handleLogoClick}> */}
            {/* eslint-disable */

            currentOrg.white_labeled === 1 && currentOrg.logo !== null ? (
              <Avatar
                className={classes.organizationLogo}
                src={JSON.parse(currentOrg.logo).url}
              />
            ) : currentOrg.white_labeled === 1 && currentOrg.logo === null ? (
              <Avatar className={classes.organizationLogo} src={noLogo} />
            ) : (
              <img
                src={iconLogo}
                className={classes.logo}
                alt="FirstLine Social Logo"
              />
            ) /* eslint-enable */}

            {/* </Button> */}
          </Box>
          {/* <Box className={classes.userContainer}>
            <Box className={classes.textContainer}>
              <Typography
                className={classes.user}
                variant="body2"
                color="secondary"
              >
                {firstName + " " + lastName}
              </Typography>
              <Typography className={classes.role}>{role}</Typography>
            </Box>
            <Box>
              <Button onClick={handleClick}>
              <Avatar
                className={classes.avatar}
                src={cl.url(profile_image, {
                  width: 150,
                  crop: "scale"
                })}
              />
              </Button>
              <Menu
                className={classes.menu}
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
              >
                <MenuItem onClick={handleOpenUpdateUser}>Edit Profile</MenuItem>
                <MenuItem onClick={handleLogOut}>Log Out</MenuItem>
              </Menu>
            </Box>
          </Box> */}
        </Toolbar>
      </AppBar>
    </Fragment>
  )
}

export default withStyles(styles)(AdminHeader)



// WEBPACK FOOTER //
// ./src/components/AdminHeader/index.jsx